import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {

    new Swiper('.menusSwiper', {

        modules: [Navigation, Pagination],

        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,

        navigation: {
            nextEl: '.switch_menus',
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

});